module.exports = __webpack_public_path__ + "img/yewu.578a882b.png";